import { Box, Typography } from "@mui/material";

interface TacticalBannerProps {
  position: "top" | "bottom";
}

export const TacticalBanner = ({ position }: TacticalBannerProps) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        position: "fixed",
        bottom: position === "bottom" ? 0 : "auto",
        top: position === "top" ? 0 : "auto",
        width: "100%",
        zIndex: 10000,
        backgroundColor: "green",
        py: 0.5,
      }}
    >
      <Typography color={"white"} variant="body2">
        CUI//FEDCON
      </Typography>
    </Box>
  );
};
